import { productEnabled } from '@get-bridge/learn-legacy-shared/dist/utils/accountConfig';
import isFeatureEnabled from '@get-bridge/learn-legacy-shared/dist/utils/isFeatureEnabled';
import { isRootAccount } from '@get-bridge/learn-legacy-shared/dist/utils/accountConfig';

export default {
  today: hosts =>
    hosts.perform &&
    productEnabled('perform') && {
      id: 'SECONDARY_ME_TODAY',
      host: hosts.perform,
      href: '/talent/home',
      name: I18n.t('Today'),
    },
  skillPlan: hosts =>
    hosts.perform &&
    productEnabled('career') && {
      id: 'SECONDARY_ME_DEVELOPMENT_PLAN',
      host: hosts.perform,
      href: '/career/development-plan',
      name: I18n.t('Development Plan'),
    },
  careerVision: hosts =>
    hosts.perform &&
    productEnabled('career') && {
      id: 'SECONDARY_ME_CAREER_VISION',
      host: hosts.perform,
      href: '/everest',
      name: I18n.t('Career Vision'),
    },
  history: (hosts, user) =>
    hosts.perform &&
    productEnabled('perform') && {
      id: 'SECONDARY_ME_HISTORY',
      host: hosts.perform,
      href: `/talent/timeline/${user.id}`,
      name: I18n.t('History'),
    },
  goals: (hosts, user) =>
    hosts.perform &&
    productEnabled('perform') && {
      id: 'SECONDARY_ME_GOALS',
      host: hosts.perform,
      href: `/talent/goals/${user.id}`,
      name: I18n.t('Goals'),
      okrName: I18n.t('Objectives'),
    },
  feedback: hosts =>
    hosts.perform &&
    productEnabled('perform') && {
      id: 'SECONDARY_ME_FEEDBACK',
      host: hosts.perform,
      href: '/talent/assessment/home',
      name: I18n.t('Feedback'),
    },
  learning: (hosts, myLearningOnRuntime) => {
    if (myLearningOnRuntime && !hosts.perform) return null;
    if (!myLearningOnRuntime && !hosts.learn) return null;
    return {
      id: 'SECONDARY_ME_LEARNING',
      host: myLearningOnRuntime ? hosts.perform : hosts.learn,
      href: '/learner/courses',
      otherHrefs: [
        '/learner/library',
        '/learner/calendar',
        '/learner/category/.*',
        '/learner/approver/approvals',
        '/learner/training/.*/enroll',
      ],
      name: I18n.t('Learning'),
    };
  },
  journeys: hosts =>
    hosts.perform &&
    isFeatureEnabled('journeys_mvp') &&
    (isRootAccount() || isFeatureEnabled('journeys_subaccount_support')) && {
      id: 'SECONDARY_ME_JOURNEYS',
      host: hosts.perform,
      href: '/journeys',
      otherHrefs: ['/journeys/.*'],
      name: I18n.t('Journeys'),
    },
  profile: (hosts, user) =>
    hosts.perform &&
    productEnabled('connect') && {
      id: 'SECONDARY_ME_PROFILE',
      host: hosts.perform,
      href: `/connect/profiles/${user.id}`,
      name: I18n.t('My Profile'),
    },
  tools: hosts =>
    hosts.learn && {
      id: 'LTI_TOOLS_PLACEHOLDER_LEARNER_NAV',
      host: hosts.learn,
      href: '#',
      name: I18n.t('Tools'),
    },
};



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/utils/buildAtlasLinks/primaryLinks/me.js